/**
 * Return an article only when it is safe for public routing.
 * @template T
 * @param {(T & {draft?: boolean}) | null | undefined} article
 * @returns {T | null}
 */
export const publicResource = (article) => (article && !article.draft ? article : null);
